/* eslint-disable */

export default {
    data() {
        return {
        };
    },
    
    methods: {
      tagNav: function(btn, screen) {
                var obj={ 
                    hitType: 'event',
                    eventCategory: 'TED Triggers & Flares Navigation',
                    eventAction: btn+' Click',
                    eventLabel: screen+' Screen',
                };
                try {
                console.log("sending Message:", JSON.stringify(obj));
                window.top.postMessage(JSON.stringify(obj), "*");
                } catch(e) {
                console.log("error sending Message");
                }
            },
            
            tagInput: function(ques, ans) {
                var obj={ 
                    hitType: 'event',
                    eventCategory: 'TED Triggers',
                    eventAction: ques+' Question Submission',
                    eventLabel: ans,
                };
                try {
                console.log("sending Message:", JSON.stringify(obj));
                window.top.postMessage(JSON.stringify(obj), "*");
                } catch(e) {
                console.log("error sending Message");
                }
            },
    }
  };